import axios from 'axios';
import axiosInstance from "./axiosInterceptor";

import history from '../../history';
import { AUTH_API, BASE_API, IDM_API } from '../../Config';

import {
    LOGOUT_USER,
    TRYING_LOGIN_USER, TRYING_LOGIN_USER_SUCCESS, TRYING_LOGIN_USER_ERROR,
    TRYING_GET_DATA, TRYING_GET_DATA_SUCCESS, TRYING_GET_DATA_ERROR
} from '../Types';

export const CheckLogin = () => async dispatch => {
    var Token = localStorage.getItem("accessToken");
  
    if (Token) {
        dispatch({ type: TRYING_LOGIN_USER });

        const response = await axiosInstance.post(`${IDM_API}user/getUserProfile`);

        if (response.data.Response === 1) {
            var { data } = response.data;

            var UserDetails = data ? data[0] : [];

            dispatch({ type: TRYING_LOGIN_USER_SUCCESS, payload: UserDetails });
        } else {
            dispatch({ type: TRYING_LOGIN_USER_ERROR, payload: response.data.ErrorMessage });

            if (!response.data.IsTokenValid) LogoutUserFunc();
            // dispatch({ type: UPDATE_ERROR_MODAL_WARNING, payload: { ModalError: response.data.ErrorMessage } });
        }
    }
    else {
        dispatch({ type: LOGOUT_USER });
        history.push('/login');
    }
}

export const GetDHCDashboard = ({ DHCId, EndDate, StartDate }) => async dispatch => {
    dispatch({ type: TRYING_GET_DATA });
  
    var data = { DHCId, EndDate, StartDate };
  
    const response = await axiosInstance.post(`${BASE_API}management/GetDHCDashboard`, { ...data });
  
    if (response.data.Response === 1) {
        var { Charts, Segments, Totals } = response.data;
        
        dispatch({ type: TRYING_GET_DATA_SUCCESS });
        
        return { Charts, Segments, Totals };
    } else dispatch({ type: TRYING_GET_DATA_ERROR, payload: response.data.ErrorMessage });

    return {};
}

export const GetDHCDetails = ({ DHCId }) => async dispatch => {
    dispatch({ type: TRYING_GET_DATA });
  
    var data = { DHCId };
  
    const response = await axiosInstance.post(`${BASE_API}management/GetDHCDetails`, { ...data });
  
    if (response.data.Response === 1) {
        var { DHCDetails } = response.data;
        
        dispatch({ type: TRYING_GET_DATA_SUCCESS });
        
        return { DHCDetails };
    } else dispatch({ type: TRYING_GET_DATA_ERROR, payload: response.data.ErrorMessage });

    return {};
}

export const GetEndUsers = ({ EndDate, PageNo, PageSize, SortCol, SortDir, StartDate }) => async dispatch => {
    dispatch({ type: TRYING_GET_DATA });

    if (PageNo === 0) PageNo = 1;
  
    var data = { EndDate, PageNo, PageSize, SortCol, SortDir, StartDate };
  
    const response = await axiosInstance.post(`${BASE_API}management/GetEndUsers`, { ...data });
  
    if (response.data.Response === 1) {
        var { EndUsers, TotalRecords } = response.data;
        
        dispatch({ type: TRYING_GET_DATA_SUCCESS });
        
        return { EndUsers, TotalRecords };
    } else dispatch({ type: TRYING_GET_DATA_ERROR, payload: response.data.ErrorMessage });

    return {};
}

export const GetHealthCounselors = ({ EndDate, PageNo, PageSize, SortCol, SortDir, StartDate }) => async dispatch => {
    dispatch({ type: TRYING_GET_DATA });

    if (PageNo === 0) PageNo = 1;
  
    var data = { EndDate, PageNo, PageSize, SortCol, SortDir, StartDate };
  
    const response = await axiosInstance.post(`${BASE_API}management/GetHealthCounselors`, { ...data });
  
    if (response.data.Response === 1) {
        var { DHCs, TotalRecords } = response.data;
        
        dispatch({ type: TRYING_GET_DATA_SUCCESS });
        
        return { DHCs, TotalRecords };
    } else dispatch({ type: TRYING_GET_DATA_ERROR, payload: response.data.ErrorMessage });

    return {};
}

export const GetProducts = ({ EndDate, PageNo, PageSize, SortCol, SortDir, StartDate }) => async dispatch => {
    dispatch({ type: TRYING_GET_DATA });

    if (PageNo === 0) PageNo = 1;
  
    var data = { EndDate, PageNo, PageSize, SortCol, SortDir, StartDate };
  
    const response = await axiosInstance.post(`${BASE_API}management/GetProducts`, { ...data });
  
    if (response.data.Response === 1) {
        var { Products, TotalRecords } = response.data;
        
        dispatch({ type: TRYING_GET_DATA_SUCCESS });
        
        return { Products, TotalRecords };
    } else dispatch({ type: TRYING_GET_DATA_ERROR, payload: response.data.ErrorMessage });

    return {};
}

export const LoginUser = ({ email, password }) => async dispatch => {
    dispatch({ type: TRYING_LOGIN_USER });
  
    var data = { email, password };
  
    const response = await axios.post(`${AUTH_API}login`, { ...data });

    console.log('response: ', response);
  
    if (response.status === 201) {
        var { accessToken, refreshToken } = response.data.result;
        
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);
        dispatch({ type: TRYING_LOGIN_USER_SUCCESS });
    
        window.location.href = `/dashboard`;
    } else dispatch({ type: TRYING_LOGIN_USER_ERROR, payload: response.data.ErrorMessage });
}

export const LogoutUser = () => async dispatch => {
    LogoutUserFunc();
    dispatch({ type: LOGOUT_USER });

    history.push('/login');
}

function LogoutUserFunc() {
    localStorage.clear();
}